module.exports = __webpack_public_path__ + "img/vip-coupon-btn-bg.3024ace4.png";